// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FileList_componentWrapper__srkyz"};